<template>
  <div class="commissioning-list pa-10">
    <title-page>{{ $t('onboarding.queue.title') }}</title-page>
    <p class="text-body-2 text--secondary mb-4">{{ $t('onboarding.queue.subtitle') }}</p>
    <order-queue />
  </div>
</template>

<script>
import OrderQueue from './Queue/OrderQueue.vue'

/**
 * Les commandes en attente, toutes organisations du périmètre : bornes, compteurs, véhicules et badges dans les mêmes
 * files de travail — à valider, badges à envoyer ou à remettre, poses à planifier… —, chacune avec son geste.
 * Remplace la liste des commandes et celle des envois de badges.
 */
export default {
  name: 'CommissioningList',

  components: { OrderQueue },
}
</script>
